import React from 'react';
import $t from 'locales/en/translation';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button';
import HomeLoanInfoCard from '../components/HomeLoanInfoCard';

const AboutMortgagesModuleView = props => {
  const { datatestid, seenPixel } = props;

  return (
    <>
      {seenPixel}
      <SectionContainer>
        <Row>
          <Label
            datatestid={`${datatestid}-needToKnow-title`}
            typeHeader={'h3'}
            type="H3"
          >
            About Mortgages
          </Label>
          <HomeLoanInfoCard
            title={$t.getASenseOfHowMuch}
            detail={$t.howMuchYouCanAffort}
            classname="calculatorIcon"
            datatestid={`${datatestid}-howMuchCanYouAfford`}
          />
          <div className="mobileCenter text-right">
            <Button
              mrphType="standard"
              className="margT48 m-margT32 inblock border-rad100px"
              onClick={props.onClickGotoCalculator}
              datatestid={`${datatestid}-calculate-mp`}
            >
              {$t.calculateMonthlyPayment}
            </Button>
          </div>
          <HomeLoanInfoCard
            title={$t.findARealEstateAgent}
            detail={$t.realEstateAgentsWillHelp}
            classname="ealestateagentIcon"
            datatestid={`${datatestid}-findRealEstateAgent`}
          />
          <HomeLoanInfoCard
            title={$t.gatherDocuments}
            detail={$t.documentsLenderWillAsk}
            classname="documentsIcon"
            datatestid={`${datatestid}-lenderDocuments`}
          />
          <HomeLoanInfoCard
            title={$t.chooseRighLender}
            detail={props?.config?.home_loan?.about_mortgages?.subTitle}
            classname="homelenderIcon"
            datatestid={`${datatestid}-findALender`}
          />
        </Row>
      </SectionContainer>
    </>
  );
};

export default AboutMortgagesModuleView;
